import React from 'react';
import { mount } from 'enzyme';
import { act } from 'react-dom/test-utils';
import axios from 'axios';
import GoalRatingForm from '../../../components/goal_performance/GoalRatingForm';
import GoalReadOnlyList from '../../../components/goal_performance/GoalReadOnlyList';
import MilestoneList from '../../../components/goals/MilestoneList';

jest.mock('axios', () => ({ post: jest.fn(), put: jest.fn(), delete: jest.fn() }));
jest.mock('js-cookie', () => ({ get: jest.fn(() => '/api/v2') }));
jest.mock('../../../stores/ToastStore', () => ({ showToast: jest.fn() }));
jest.mock('../../../components/goals/MilestoneList.css', () => ({}));
jest.mock('../../../assets/Progress.svg', () => 'progress');
jest.mock('../../../assets/editIcon.svg', () => 'edit');
jest.mock('../../../assets/Delete.svg', () => 'delete');
jest.mock('../../../components/goals/GoalProgressRow', () => ({ goal }) => require('react').createElement('output', { 'data-progress': goal.progress }));
jest.mock('../../../components/buttons-20250224T111359Z-001/buttons/FilledButton.jsx', () => ({ text, ...props }) => require('react').createElement('button', props, text));
jest.mock('../../../components/buttons-20250224T111359Z-001/buttons/TextButton.jsx', () => ({ text, ...props }) => require('react').createElement('button', { ...props, 'data-text-button': true }, text));
jest.mock('../../../components/buttons-20250224T111359Z-001/buttons', () => ({
  FilledButton: ({ text, children, ...props }) => require('react').createElement('button', props, children || text),
  TextButton: ({ text, ...props }) => require('react').createElement('button', props, text),
}));
jest.mock('../../../stores/CurrentUserStore', () => ({ activeAccount: {} }));
jest.mock('../../../components/goal_performance/MyAssessmentView.css', () => ({}));
jest.mock('flexbox-react', () => ({ children }) => require('react').createElement('div', null, children));
jest.mock('@blueprintjs/core', () => {
  const React = require('react');
  return {
    Button: ({ text, onClick, disabled, 'aria-label': label }) => React.createElement('button', { onClick, disabled, 'aria-label': label }, text),
    Checkbox: ({ checked, onChange, disabled, children }) => React.createElement('label', null, React.createElement('input', { type: 'checkbox', checked, onChange, disabled }), children),
    Collapse: ({ children }) => React.createElement('div', null, children),
    Dialog: ({ isOpen, children }) => isOpen ? React.createElement('section', { 'data-dialog': true }, children) : null,
    Drawer: ({ isOpen, children }) => isOpen ? React.createElement('section', { 'data-drawer': true }, children) : null,
    FormGroup: ({ label, children }) => React.createElement('div', null, React.createElement('label', null, label), children),
    Slider: ({ onChange, labelStepSize, ...props }) => React.createElement('input', { ...props, type: 'range', onChange: event => onChange(Number(event.target.value)) }),
    Spinner: props => React.createElement('span', { 'data-spinner': true, ...props }),
    Card: ({ children }) => React.createElement('div', null, children),
    Tooltip: ({ children }) => React.createElement('div', null, children),
    Divider: () => null,
    HTMLSelect: () => null,
    Icon: () => null,
    TextArea: props => React.createElement('textarea', props),
  };
});
const subGoal = { id: 's1', progress: 70, milestones: [{ id: 'm1', title: 'One', progress: 25 }] };
const params = { sub_goal_id: 's1', goal_setting_id: 'cycle1', user_id: 'employee-sourabh' };
const create = props => mount(<MilestoneList subGoal={subGoal} goalSettingId="cycle1" userId="employee-sourabh" editable onRefresh={() => Promise.resolve({ goals: [] })} {...props} />);
const button = (wrapper, text) => wrapper.find('button').filterWhere(node => node.text() === text);
const submit = async wrapper => {
  await act(async () => { wrapper.find('form').simulate('submit', { preventDefault() {} }); });
  wrapper.update();
};
beforeEach(() => {
  jest.clearAllMocks();
  axios.post.mockResolvedValue({ data: { message: 'Created' } });
  axios.put.mockResolvedValue({ data: { message: 'Updated' } });
  axios.delete.mockResolvedValue({ data: { message: 'Deleted' } });
});

test('secondary milestone/task actions render as white and blue action buttons', () => {
  const wrapper = create();
  const milestoneButton = button(wrapper, '+ Add milestone');
  const taskButton = button(wrapper, '+ Add task');

  expect(milestoneButton).toHaveLength(1);
  expect(taskButton).toHaveLength(1);
  expect(milestoneButton.at(0).prop('style')).toMatchObject({
    backgroundColor: '#ffffff',
    color: '#1870d5',
    border: '1px solid #1870d5'
  });
  expect(taskButton.at(0).prop('style')).toMatchObject({
    backgroundColor: '#ffffff',
    color: '#1870d5',
    border: '1px solid #1870d5'
  });
  wrapper.unmount();
});

test('direct create/update use the target employee and show GIF after TextButton Cancel', async () => {
  const wrapper = create();
  await act(async () => { button(wrapper, '+ Add milestone').simulate('click'); });
  wrapper.update();
  expect(wrapper.find('form')).toHaveLength(0);
  expect(axios.post).toHaveBeenCalledWith('/api/v2/milestone', params);
  let completeUpdate;
  axios.put.mockImplementation(() => new Promise(resolve => { completeUpdate = resolve; }));
  wrapper.find('button[aria-label="Edit milestone: One"]').simulate('click');
  wrapper.find('input[name="title"]').simulate('change', { target: { value: 'Updated one' } });
  wrapper.find('form').simulate('submit', { preventDefault() {} });
  wrapper.find('form').simulate('submit', { preventDefault() {} });
  expect(axios.put).toHaveBeenCalledTimes(1);
  expect(axios.put).toHaveBeenCalledWith('/api/v2/milestone/m1', { ...params, title: 'Updated one', progress: 25 });
  const footer = wrapper.find('.milestone-form-actions');
  expect(footer.find('button').map(n => n.text())).toEqual(['Saving...', 'Cancel']);
  expect(footer.find('button[data-text-button=true]').prop('disabled')).toBe(true);
  expect(footer.find('img').prop('alt')).toBe('Saving...');
  expect(footer.find('button img')).toHaveLength(0);
  await act(async () => { completeUpdate({ data: { message: 'Updated' } }); });
  wrapper.update();
  expect(wrapper.find('form')).toHaveLength(0);
  wrapper.unmount();
});

test('failed requests retain input; deletion passes all scope ids', async () => {
  const wrapper = create();
  axios.put.mockRejectedValue({ response: { data: { error: 'Cycle locked' } } });
  wrapper.find('button[aria-label="Edit milestone: One"]').simulate('click');
  await submit(wrapper);
  expect(wrapper.find('[role="alert"]').text()).toBe('Cycle locked');
  expect(wrapper.find('input[name="title"]').prop('value')).toBe('One');
  button(wrapper, 'Cancel').simulate('click');
  wrapper.find('button[aria-label="Delete milestone: One"]').simulate('click');
  await act(async () => { button(wrapper, 'Delete').simulate('click'); });
  wrapper.update();
  expect(axios.delete).toHaveBeenCalledWith('/api/v2/milestone/m1', { params });
  expect(wrapper.find('[data-dialog=true]')).toHaveLength(0);
  wrapper.unmount();
});

test('task create, edit, completion and delete use scoped API payloads', async () => {
  const onRefresh = jest.fn(() => Promise.resolve({ goals: [] }));
  const task = { id: 't1', title: 'Task A', status: 1 };
  const data = { ...subGoal, milestones: [{ ...subGoal.milestones[0], progress: 100, tasks: [task] }] };
  const wrapper = create({ subGoal: data, onRefresh });
  await act(async () => { button(wrapper, '+ Add task').simulate('click'); });
  wrapper.update();
  expect(wrapper.find('form')).toHaveLength(0);
  expect(axios.post).toHaveBeenCalledWith('/api/v2/task', { ...params, milestone_id: 'm1' });
  expect(wrapper.find('input[type="checkbox"]').prop('checked')).toBe(true);
  expect(wrapper.find('output').prop('data-progress')).toBe(100);
  wrapper.find('button[aria-label="Edit task: Task A"]').simulate('click');
  wrapper.find('input[name="title"]').simulate('change', { target: { value: ' Task B ' } });
  await submit(wrapper);
  expect(axios.put).toHaveBeenLastCalledWith('/api/v2/task/t1', { ...params, milestone_id: 'm1', title: 'Task B', status: 1 });
  await act(async () => { wrapper.find('input[type="checkbox"]').simulate('change', { target: { checked: false } }); });
  expect(axios.put).toHaveBeenLastCalledWith('/api/v2/task/t1', { ...params, milestone_id: 'm1', title: 'Task A', status: 0 });
  wrapper.find('button[aria-label="Delete task: Task A"]').simulate('click');
  await act(async () => { button(wrapper, 'Delete').simulate('click'); });
  wrapper.update();
  expect(axios.delete).toHaveBeenCalledWith('/api/v2/task/t1', { data: { ...params, milestone_id: 'm1' } });
  expect(onRefresh).toHaveBeenCalledTimes(4);
  expect(subGoal.progress).toBe(70);
  wrapper.unmount();
});

test('empty toggles are disabled; create is locked and shows a loader until refresh finishes', async () => {
  const empty = create({ subGoal: { id: 's1', milestones: [] } });
  expect(button(empty, '0 Milestones').prop('disabled')).toBe(true);
  empty.unmount();
  let finish;
  const onRefresh = jest.fn(() => new Promise(resolve => { finish = resolve; }));
  const wrapper = create({ onRefresh });
  expect(button(wrapper, '0 Tasks').prop('disabled')).toBe(true);
  await act(async () => {
    button(wrapper, '+ Add task').simulate('click');
    button(wrapper, '+ Add task').simulate('click');
  });
  wrapper.update();
  expect(axios.post).toHaveBeenCalledTimes(1);
  expect(wrapper.find('[data-spinner=true]')).toHaveLength(1);
  expect(button(wrapper, '+ Add milestone').prop('disabled')).toBe(true);
  await act(async () => { finish({ goals: [] }); });
  wrapper.update();
  expect(wrapper.find('[data-spinner=true]')).toHaveLength(0);
  wrapper.unmount();
});

test('failed completion keeps server state and permits retry', async () => {
  const wrapper = create({ subGoal: { id: 's1', milestones: [{ id: 'm1', tasks: [{ id: 't1', title: 'A', status: 0 }] }] } });
  axios.put.mockRejectedValue({ response: { data: { error: 'Update failed' } } });
  await act(async () => { wrapper.find('input[type="checkbox"]').simulate('change', { target: { checked: true } }); });
  wrapper.update();
  expect(wrapper.find('input[type="checkbox"]').prop('checked')).toBe(false);
  expect(wrapper.find('input[type="checkbox"]').prop('disabled')).toBe(false);
  expect(wrapper.find('[role="alert"]').text()).toBe('Update failed');
  wrapper.unmount();
});

test('read-only hides mutation controls and missing employee blocks API writes', async () => {
  const readonly = create({ editable: false });
  expect(button(readonly, '+ Add milestone')).toHaveLength(0);
  readonly.unmount();
  const wrapper = create({ userId: null });
  await act(async () => { button(wrapper, '+ Add milestone').simulate('click'); });
  wrapper.update();
  expect(axios.post).not.toHaveBeenCalled();
  expect(wrapper.find('[role="alert"]').text()).toContain('Missing');
  wrapper.unmount();
});

const reviewGoal = {
  id: 'g1', title: 'Goal', progress: 65, cascade_id: 'cascade1',
  sub_goals: [{ id: 's1', title: 'Sub-goal', progress: 0,
    milestones: [{ id: 'm1', title: 'Milestone', progress: 75,
      tasks: [{ id: 't1', title: 'Completed task', status: 1 }] }] }]
};

test.each(['rating', 'readOnly'])('%s review displays nested milestones/tasks as read-only, including cascade children', mode => {
  const props = { openSubGoals: { g1: true }, toggleSubGoals: jest.fn(), subGoalsByGoalId: { g1: [] } };
  const wrapper = mount(mode === 'rating'
    ? <GoalRatingForm {...props} goalList={[reviewGoal]} goalRatings={{}} />
    : <GoalReadOnlyList {...props} data={[reviewGoal]} />);
  expect(wrapper.text()).toContain('Sub-goal');
  expect(wrapper.text()).toContain('Milestone');
  expect(wrapper.text()).toContain('Completed task');
  expect(wrapper.find('output').map(node => node.prop('data-progress'))).toEqual([65, 0, 75]);
  expect(wrapper.find('input[type="checkbox"]').prop('checked')).toBe(true);
  expect(wrapper.find('input[type="checkbox"]').prop('disabled')).toBe(true);
  expect(button(wrapper, '+ Add milestone')).toHaveLength(0);
  expect(button(wrapper, '+ Add task')).toHaveLength(0);
  expect(wrapper.find('button[aria-label]')).toHaveLength(0);
  wrapper.unmount();
});

test('milestones without tasks allow saving manual progress including zero', async () => {
  const onRefresh = jest.fn(() => Promise.resolve({ goals: [] }));
  const wrapper = create({ onRefresh });
  for (const progress of [65, 0]) {
    wrapper.find('button[aria-label="Edit milestone: One"]').simulate('click');
    expect(wrapper.find('input[type="range"]').prop('value')).toBe(25);
    wrapper.find('input[type="range"]').simulate('change', { target: { value: String(progress) } });
    await submit(wrapper);
    expect(axios.put).toHaveBeenLastCalledWith('/api/v2/milestone/m1', { ...params, title: 'One', progress });
  }
  expect(onRefresh).toHaveBeenCalledTimes(2);
  wrapper.unmount();
});

test('milestones with tasks keep task-derived progress when editing the title', async () => {
  const wrapper = create({ subGoal: { ...subGoal, milestones: [{ ...subGoal.milestones[0], tasks: [{ id: 't1', title: 'Task', status: 0 }] }] } });
  wrapper.find('button[aria-label="Edit milestone: One"]').simulate('click');
  expect(wrapper.find('input[type="range"]')).toHaveLength(0);
  await submit(wrapper);
  expect(axios.put).toHaveBeenCalledWith('/api/v2/milestone/m1', { ...params, title: 'One' });
  wrapper.unmount();
});
